export const READ_TIMEOUT_MS = 30_000;
export class RequestTimeoutError extends Error {
  constructor() { super("This took too long. Check your connection and try again."); this.name = "RequestTimeoutError"; }
}

/** Stop waiting even when an injected API ignores cancellation; late results cannot settle this read. */
export function requestTimeout<T>(read: (signal: AbortSignal) => Promise<T>, signal?: AbortSignal, timeoutMs = READ_TIMEOUT_MS): Promise<T> {
  const controller = new AbortController();
  return new Promise<T>((resolve, reject) => {
    const abort = () => { controller.abort(); reject(new DOMException("The request was cancelled", "AbortError")); };
    const timer = setTimeout(() => {
      controller.abort();
      reject(new RequestTimeoutError());
    }, timeoutMs);
    const clean = () => { clearTimeout(timer); signal?.removeEventListener("abort", abort); controller.signal.removeEventListener("abort", clean); };
    signal?.addEventListener("abort", abort, { once: true });
    if (signal?.aborted) { abort(); clean(); return; }
    Promise.resolve().then(() => read(controller.signal)).then(resolve, reject).finally(clean);
    controller.signal.addEventListener("abort", clean, { once: true });
  });
}
